import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {AlertComponent} from "../../../shared/components/alert/alert.component";
import {LoadingComponent} from "../../../shared/components/loading/loading.component";
import {
  auditEntityActionName, AuditEntityDataModel, AuditEventEntityListModel,
  AuditEventEntityModel,
  auditFriendlyName
} from '../../../core/models/audit/audit-event.model';
import { CommonModule, DatePipe } from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {AuditService} from '../../../core/services/audit/audit.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ButtonComponent} from '../../../shared/components/button/button.component';
import {formatElapsed} from '../../../core/helpers/date-timer.helper';
import {ModalComponent} from '../../../shared/components/modal/modal.component';
import {DiffEditorComponent} from 'ngx-monaco-editor-v2';

@Component({
  selector: 'app-audit-event-view',
  imports: [
    DatePipe,
    AlertComponent,
    LoadingComponent,
    TranslateModule,
    CommonModule,
    ButtonComponent,
    ModalComponent,
    DiffEditorComponent
  ],
  templateUrl: './audit-event-view.component.html',
  styleUrl: './audit-event-view.component.scss'
})
export class AuditEventViewComponent implements OnInit {

  error: string | null = null;
  loading: boolean = false;

  @ViewChild('entityModal') jsonModalRef!: ModalComponent;

  auditEvent: AuditEventEntityModel | null = null;

  modalTitle: string = '';
  modalLoading: boolean = false;
  modalError: string | null = null;
  modalData: AuditEntityDataModel | null = null;

  originalModel: { language: string, code: string } | null = null;
  modifiedModel: { language: string, code: string } | null = null;
  diffOptions = { readOnly: true, theme: 'vs-dark', automaticLayout: true };

  constructor(private readonly auditService: AuditService,
              private readonly route: ActivatedRoute) {
  }

  ngOnInit(): void {
    const eventId = Number(this.route.snapshot.paramMap.get('eventId') ?? '0');
    if (eventId < 1) {
      return;
    }

    this.loadData(eventId);
  }

  loadData(eventId: number): void {
    this.loading = true;
    this.error = null;

    this.auditService.getEventWithEntities(eventId).subscribe({
      next: (result) => {
        this.auditEvent = result;
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Falha ao carregar os dados.';
        this.loading = false;
        console.error(err);
      }
    });
  }

  onOpenModal(data: AuditEventEntityListModel): void {
    this.modalLoading = true;
    this.modalError = null;
    this.modalTitle = `[${data.action}] ${data.entityName}`;
    this.jsonModalRef.openDialog();

    this.auditService.getEventEntityData(data.id).subscribe({
      next: (result) => {
        this.modalLoading = false;
        this.modalData = result;
        const before = this.prettyJson(result.entityBefore);
        const after = this.prettyJson(result.entityAfter);
        this.originalModel = { language: 'json', code: before };
        this.modifiedModel = { language: 'json', code: after };
      },
      error: (err) => {
        this.modalError = 'Falha ao carregar os dados.';
        this.modalLoading = false;
        console.error(err);
      }
    });
  }

  protected readonly formatElapsed = formatElapsed;
  protected readonly auditFriendlyName = auditFriendlyName;
  protected readonly auditEntityActionName = auditEntityActionName;

  private prettyJson(input: string | null | undefined): string {
    if (!input) return '';
    try {
      const obj = JSON.parse(input);
      return JSON.stringify(obj, null, 2);
    } catch {
      return input as string;
    }
  }
}
